import React, { useState } from 'react';
import styled from 'styled-components';
import { Formik, yupToFormErrors } from 'formik';
import Form from 'components/ui/Form';
import * as Yup from 'yup';
import Row from 'components/ui/Row';
import Col from 'components/ui/Col';
import Spacer from 'components/ui/Spacer';
import TextBox from 'components/ui/TextBox';
import CheckboxNormal from 'components/ui/CheckboxNormal';

import { getTranslatedString } from 'helpers/i18n';
import { apiPut } from 'helpers/ApiHelper';
import Auth from 'j-toker';

const FullWidthTextArea = styled(TextBox.TextArea)`
  width: 100%;
`;

const StyledForm = styled.form`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

const AssistanceRequestForm = ({ cotenantId, formName, formData, onLoadingChange, onSubmissionComplete }) => {
  const [charLength, setCharLength] = useState((formData.assistance_request && formData.assistance_request.length) || 0);

  const handleFormSubmit = (data, resetForm) => {
    onLoadingChange({ isError: false, isLoading: true, values: data });
    apiPut(
      Auth.getApiUrl() + `/landlords/tenants/${cotenantId}/update_assistance_request`, 
      { assistance_request: data.assistance_request, requires_assistance: data.requires_assistance }
    ).then(() => {
      onSubmissionComplete(data);
    }).catch(error => {
      onLoadingChange({ isError: true, isLoading: false, values: data });
    })
  };

  const validateForm = async (values) => {
    let validationSchema = {
      assistance_request: Yup.string().required(getTranslatedString('required'))
    };
    const schema = Yup.object().shape(validationSchema);
    return schema.validate(values, { abortEarly: false }).catch((error) => {
      throw yupToFormErrors(error);
    });
  };
  
  const handleCheckboxChanged = (setFieldValue, value) => {
    setFieldValue('requires_assistance', value);
  }

  const handleTextChanged = (setFieldValue, value) => {
    if (value.length <= 250) {
      setFieldValue('assistance_request', value);
      setCharLength(value.length);
    }
  }


  return (
    <React.Fragment>
      <p>{getTranslatedString('landlordPortal.residents.assistanceRequest.description')}</p>
      <p>* {getTranslatedString('landlordPortal.residents.assistanceRequest.info')}</p>

      <Formik
        initialValues={{ assistance_request: formData.assistance_request, requires_assistance: formData.requires_assistance }}
        validate={validateForm}
        onSubmit={(values, { resetForm }) => handleFormSubmit(values, resetForm)}
      >
        {({ values, errors, handleChange, handleSubmit, setFieldValue }) => (
          <StyledForm id={formName} onSubmit={handleSubmit}>
            <Spacer mb={1}>
              <Row gutter={16}>
                <Col span={24}>
                  <CheckboxNormal
                    name="requires_assistance"
                    value={values.requires_assistance}
                    checked={values.requires_assistance}
                    onChange={(e) =>  handleCheckboxChanged(setFieldValue, e.target.checked)}
                    style={{ marginTop: '15px' }}
                  >
                    {getTranslatedString('landlordPortal.residents.assistanceRequest.checkboxText')}
                  </CheckboxNormal>
                  <div>{getTranslatedString('landlordPortal.residents.assistanceRequest.textAreaLabel')} *</div>
                  <Form.Item
                    validateStatus={errors.assistance_request && 'error'}
                    help={errors.assistance_request}
                  >
                    <FullWidthTextArea
                      name="assistance_request"
                      value={values.assistance_request}
                      onChange={(e) => handleTextChanged(setFieldValue, e.target.value)}
                      placeholder=""
                      size="large"
                      rows="5"
                    />
                    {getTranslatedString('portal.assistanceRequest.charsTyped')} {': '} {charLength + "/250"}
                  </Form.Item>
                </Col>
              </Row>
            </Spacer>
          </StyledForm>
        )}
      </Formik>
    </React.Fragment>
  );
};

export default AssistanceRequestForm;
